import "./alert-modal.scss";

import * as React from "react";

import {cs}                      from "../../../../../../react/chain-services";
import {Link}           from "@Common/react/cst2";
import {upperCase1}              from "../../../../../../utils/strings";
import {GlobalEventQueue}        from "../../../../../browser/global-event-queue";
import {ModalService3}           from "@Common/ui-components/modal-service-3/modal-service-3";

export const AlertModal = ({next: rootNext}:{
    next    : Link<React.ReactNode, {
        show    : (props: {
            message      : string,
            description ?: string,
            description2?: string,
            actionName  ?: string,
        }) => void,
    }>,
}) => cs(
    ["modal", ({}, next) => ModalService3<any>({
        xToClose: false,
        xdQaName: "Alert",
        next,
        rootNext,
    })],
    ({modal}) => (
        <div className="alert-modal-9ed">
            <div className="content">
                <div className="message" xd-qa-type="label" xd-qa-name="Alert Message">
                    {modal.params.message}
                </div>
                {modal.params.description && (
                    <div className="description" xd-qa-type="label" xd-qa-name="Alert Description">
                        {modal.params.description}
                    </div>
                )}
                {modal.params.description2 && (
                    <div className="description" xd-qa-type="label" xd-qa-name="Alert Description 2">
                        {modal.params.description2}
                    </div>
                )}
            </div>
            <div className="footer">
                {OnGlobalKeyDownEnter({
                    action: () => modal.close(),
                })}

                <button
                    className="proceed"
                    xd-qa-type="button"
                    xd-qa-name={modal.params.actionName ? upperCase1(modal.params.actionName) : "OK"}
                    onClick={() => modal.close()}
                >
                    {modal.params.actionName ? upperCase1(modal.params.actionName) : "OK"}
                </button>
            </div>
        </div>
    ),
);

const OnGlobalKeyDownEnter = GlobalEventQueue({
    eventName: "keydown",
    surCheck: (e) => e.key === "Enter",
});
